export default class Processor {

    static removeDuplicatesFromItems = (items, sort, skipDups) => {
        const seen = new Set();
        if (!skipDups) {
            items = items.filter(el => {
                const duplicate = seen.has(el.itemId);
                seen.add(el.itemId);
                return !duplicate;
            });
        }
        if (sort) {
            items.sort(function (a, b) {
                if (sort === 'EndTimeSoonest') {
                    return Date.parse(a.itemEndDate) - Date.parse(b.itemEndDate);
                } else if (sort === 'StartTimeNewest') {
                    return Date.parse(b.itemCreationDate) - Date.parse(a.itemCreationDate);
                } else if (sort === 'WatchCountDecreaseSort') {
                    let bCount = 0;
                    let aCount = 0;
                    if ('watchCount' in b.listingInfo[0]) {
                        bCount = b.listingInfo[0].watchCount[0];
                    }
                    if ('watchCount' in a.listingInfo[0]) {
                        aCount = a.listingInfo[0].watchCount[0];
                    }
                    return bCount - aCount;
                }
            });
        }
        return items;
    }

    static convertPrices = async (items, currencyApi) => {
        let price;
        let priceCurrency;
        let priceConverted;
        let currentCurrency = currencyApi.getCurrency();
        let buyItNowPrice;
        let buyItNowPriceCurrency;
        let buyItNowPriceConverted;
        let l = items.length;
        let currItem;
        for (let i = 0; i < l; i++) {
            currItem = items[i];
            if ("price" in currItem) {
                priceCurrency = currItem.price.currency;
                price = parseFloat(currItem.price.value);
                try {
                    priceConverted = await currencyApi.convert(price, priceCurrency);
                } catch (e) {
                    console.log(e);
                    break;
                }
                currItem.price.value = priceConverted;
                currItem.price.currency = currentCurrency;
            }
            if ('currentBidPrice' in currItem) {
                buyItNowPrice = parseFloat(currItem.currentBidPrice.value);
                buyItNowPriceCurrency = currItem.currentBidPrice.currency;
                try {
                    buyItNowPriceConverted = await currencyApi.convert(buyItNowPrice, buyItNowPriceCurrency)
                } catch (e) {
                    console.log(e);
                    break;
                }
                currItem.currentBidPrice.value = buyItNowPriceConverted;
                currItem.currentBidPrice.currency = currentCurrency;
            }
        }
        return items;
    }

}